export enum ActivityTypeEnum {
  INSERT = "Insert",
  UPDATE = "Update",
  DELETE = "Delete",
}
export enum EntityTypeEnum {
  InvHead = "InvoiceHeader",
  InvSeg = "InvoiceSegment",
  SegComment = "SegmentComment",
  SegItems = "InvoiceDetail",
  SegAttachment = "Attachment",
  SegCheckList = "Checklist",
  SegAttachmentImage = "AttachmentImage",
  SegLabor = "WorkInProgress",
  invSegTask = "InvoiceSegmentTask",
  serviceSchedule = "ServiceSchedule",
  workOrderSchedule = "WorkOrderSchedule",
  partOrderHeader = "PartOrderHeader",
  PartOrderLine = "PartOrderLine",
}

export enum ItemTypeEnum {
  Misc = "MC",
  Part = "PA",
  QuoteUnit = "QU",
  Remark = "RE",
  RentalUnit = "RU",
  Labor = "SL",
  TradeIn = "TR",
  Unit = "UN",
}
